import { render, staticRenderFns } from "./StockDetailPurchase.vue?vue&type=template&id=69cdff20&scoped=true&"
import script from "./StockDetailPurchase.vue?vue&type=script&lang=js&"
export * from "./StockDetailPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cdff20",
  null
  
)

export default component.exports